export class AdminApiError extends Error {
  constructor(
    message: string,
    public readonly code: number | null,
    public readonly kind: "business" | "authorization" | "redirect" = "business",
  ) {
    super(message);
    this.name = "AdminApiError";
  }
}
